import './ReviewSection.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

import profile from '../assets/image/profile-img.jpg';
import ReviewCard from './ReviewCard';
import { useRef, useEffect, useState } from 'react';
import { FaAngleLeft } from "react-icons/fa6";
import { FaAngleRight } from "react-icons/fa6";

const reviews = [
    {
        id: 1,
        rating: 5,
        heading: '"Exceptional Solutions, Exceeded Expectations!"',
        text: '"The CRP events brought our team closer and boosted morale like never before. The planning was seamless and tailored to our culture!”',
        image: profile,
        name: 'Anaya Sharma',
        role: 'HR Manager',
    },
    {
        id: 2,
        rating: 4,
        heading: '"Transformed Our Business with Innovative Tech!"',
        text: '"A fantastic initiative! Our team felt re-energized and engaged after the theme-based events. Highly recommended for any company.”',
        image: profile,
        name: 'Rajveer Mehta',
        role: 'Operations Head',
    },
    {
        id: 3,
        rating: 4,
        heading: '"Sculpted User Experiences Beyond Imagination!"',
        text: '"The attention to detail and quality of activities was superb. Our employees felt valued and connected. Will book again!"',
        image: profile,
        name: 'Priyanka Nair',
        role: 'People & Culture Lead',
    },
    {
        id: 4,
        rating: 5,
        text: '"Innovative ideas, seamless execution, and a noticeable improvement in team dynamics. CRP has truly reshaped our company culture!"',
        image: profile,
        name: 'Vikrant Joshi,',
        role: 'Director of Sales',
    },
     {
        id: 5,
        rating: 5,
        heading: '"Exceptional Solutions, Exceeded Expectations!"',
        text: '"The CRP events brought our team closer and boosted morale like never before. The planning was seamless and tailored to our culture!”',
        image: profile,
        name: 'Anaya Sharma',
        role: 'HR Manager',
    },
    {
        id: 6,
        rating: 4,
        heading: '"Transformed Our Business with Innovative Tech!"',
        text: '"A fantastic initiative! Our team felt re-energized and engaged after the theme-based events. Highly recommended for any company.”',
        image: profile,
        name: 'Rajveer Mehta',
        role: 'Operations Head',
    },
];

export default function ReviewSection() {
    const prevRef = useRef(null);
    const nextRef = useRef(null);
    const [swiperReady, setSwiperReady] = useState(false);

    useEffect(() => {
        setSwiperReady(true);
    }, []);

    return (
        <div className="review-section">
            <div className="container">
                <div className="review-section-wrapper">
                    <div className="review-section-text">
                        <h1>Loved by 100+ Corporate Teams</h1>
                    </div>

                    {swiperReady && (
                        <Swiper
                            modules={[Navigation]}
                            spaceBetween={30}
                            slidesPerView={1}
                            loop={true}
                            navigation={{
                                prevEl: prevRef.current,
                                nextEl: nextRef.current,
                            }}
                            onBeforeInit={(swiper) => {
                                swiper.params.navigation.prevEl = prevRef.current;
                                swiper.params.navigation.nextEl = nextRef.current;
                            }}
                            breakpoints={{
                                450: { slidesPerView: 1 },
                                768: { slidesPerView: 2 },
                                1024: { slidesPerView: 4 },
                            }}
                            className="review-swiper"
                        >
                            {reviews.map((review) => (
                                <SwiperSlide key={review.id}>
                                    <ReviewCard {...review} />
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    )}


                   
                        <div className="review-custom-nav-wrapper">
                            <button ref={prevRef} className="review-custom-nav-button">
                                <FaAngleLeft />
                            </button>
                            <button ref={nextRef} className="review-custom-nav-button">
                                <FaAngleRight />
                            </button>
                        </div>
                   

                </div>
            </div>
        </div>
    );
}
